import React, { useEffect, useState } from "react";
import "./Slide.css";
import { Link } from "react-router-dom";

const Slide = ({ movie, tv }) => {
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        setTimeout(() => {
            setIsLoading(false);
        }, 1500);
    }, []);

    const media = movie || tv; // Use movie if available, otherwise use tv
    const mediaType = movie ? "movie" : "tv";

    return (
        <>
            {media && (
                <Link to={`/${mediaType}/${media.id}`} style={{ textDecoration: "none", color: "white" }}>
                    <div className="cards">
                        <img className="cards__img" src={`https://image.tmdb.org/t/p/original${media.poster_path}`} />
                        <div className="cards__overlay">
                            <div className="card__title">{media.original_title || media.name}</div>
                            <div className="card__runtime">
                                {media.release_date || ""}
                                <span className="card__rating">{media.vote_average || ""}<i className="fas fa-star" /></span>
                            </div>
                            <div className="card__description">{media.overview ? media.overview.slice(0, 118) + "..." : ""}</div>
                        </div>
                    </div>
                </Link>
            )}
        </>
    );
};

export default Slide;
